// Components==============
import { faArrowRight, faHouse } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { GroupContext } from 'screens/Group/Group';
import './Route.module.scss';
// =========================

export default function Route() {
    const { group, members } = useContext(GroupContext);

    const groups = useSelector((state) =>
        state.group.entities.allIds.map((id) => state.group.entities.byId[id])
    ).sort((a, b) => a.id < b.id);

    const { location } = useHistory();

    const routeItems = [group];

    groups.forEach((g) => {
        const lastItem = routeItems[routeItems.length - 1];

        if (lastItem.parent_id === g.id) return routeItems.push(g);
    });

    const routes = routeItems.reverse();

    return (
        <div styleName="wrapper">
            <div styleName="routes">
                <NavLink to="/dashboard">
                    <FontAwesomeIcon icon={faHouse} />
                </NavLink>
                {routes.map((r, i) => (
                    <div styleName="route" key={r.id}>
                        {location.pathname === `/group/${r.id}` && i > 0 ? (
                            <h3>{r?.name}</h3>
                        ) : (
                            <NavLink
                                to={
                                    routes.length === 1
                                        ? '/dashboard'
                                        : `/group/${r.id}`
                                }
                            >
                                <h3>{r?.name}</h3>
                            </NavLink>
                        )}
                        {i !== routes.length - 1 && (
                            <FontAwesomeIcon icon={faArrowRight} />
                        )}
                    </div>
                ))}
            </div>
            <div styleName="members">
                <div>
                    <u>
                        {members.length}{' '}
                        {members.length === 1 ? 'persoon' : 'personen'}
                        <div styleName="bridge" />
                        <div styleName="tooltip">
                            {members.map(
                                (member) =>
                                    !!member && (
                                        <p key={member.id}>{member.name}</p>
                                    )
                            )}
                        </div>
                    </u>{' '}
                    <p styleName="hasAcces">
                        {members.length === 1 ? 'heeft' : 'hebben'} toegang tot
                        deze groep
                    </p>
                </div>
            </div>
        </div>
    );
}
